<template>
    <div class="text">
        <span v-html="finalText"></span>
    </div>
</template>

<script lang="ts">
import { Prop, Watch } from 'vue-property-decorator';
import * as OM from '@/model';
import { Options, Vue } from 'vue-class-component';
import linkifyHtml from 'linkify-html';

@Options({})
export default class toDoText extends Vue {

    @Prop() toDo: OM.ToDo;

    finalText: string = "";

    created(){
        if(this.toDo.text){
            this.finalText = linkifyHtml(this.toDo.text, {
                target: '_blank'
            });
        }
    }

    @Watch('toDo.text')
    onTextChange(next, prev){
        if(this.toDo.text){
            this.finalText = linkifyHtml(this.toDo.text);
        }
    }

}

</script>

<style scoped>
</style>